import { Component } from '@angular/core';

import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import { Observable } from 'rxjs';

import { IPaperFileHistoryListDialogData } from 'editing-tool/src/app/shared/components/paper/steps/details/paper-file-history-list-dialog/paper-file-history-list-dialog-data';
import { FileResponse } from 'sc-common';
import { ApiPaperDocumentFileInfo } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    templateUrl: './paper-file-history-list-dialog.component.html',
    standalone: false
})
export class PaperFileHistoryListDialogComponent {

    public readonly paperDocuments$: Observable<ApiPaperDocumentFileInfo[]>;

    public readonly downloadExpr: (data?: any) => Observable<FileResponse>;

    private readonly _dialogData: IPaperFileHistoryListDialogData;

    constructor(dialogConfig: DynamicDialogConfig) {

        this._dialogData = dialogConfig.data as IPaperFileHistoryListDialogData;

        this.paperDocuments$ = this._dialogData.paperDocuments$;

        this.downloadExpr = this._dialogData.downloadDocument;
    }
}
